import * as React from 'react';

function SvgMailScheduled(props) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.233 2.35l.234.475c.116.233.408.45.666.5l.317.05c.95.158 1.175.858.492 1.55l-.292.292c-.192.2-.3.583-.242.85l.042.175c.258 1.15-.35 1.591-1.35.991l-.217-.125a1.024 1.024 0 00-.933 0l-.217.125c-1.008.609-1.616.159-1.35-.991l.042-.175c.058-.267-.05-.65-.242-.85l-.291-.3c-.684-.692-.459-1.392.491-1.55l.317-.05c.25-.042.55-.267.667-.5l.233-.475c.45-.9 1.183-.9 1.633.008z"
        fill="#2D64BC"
      />
      <path
        d="M17.975 8.408c-.3.217-1.142.617-2.342 0a.468.468 0 00-.433 0c-.475.242-.908.342-1.25.342-.533 0-.908-.208-1.092-.342-.308-.225-.958-.866-.733-2.225a.476.476 0 00-.108-.391c-.575-.659-.892-1.542-.667-2.234.083-.275-.092-.641-.375-.641H5.833c-2.5 0-4.166 1.25-4.166 4.166v5.834c0 2.916 1.666 4.166 4.166 4.166h8.334c2.5 0 4.166-1.25 4.166-4.166V8.558c0-.158-.225-.241-.358-.15zm-6.025 1.667c-.55.442-1.25.658-1.95.658s-1.408-.216-1.95-.658L5.442 7.992a.641.641 0 01-.1-.884.623.623 0 01.875-.1l2.608 2.084c.633.508 1.708.508 2.342 0a.616.616 0 01.875.1.617.617 0 01-.092.883z"
        fill="#2D64BC"
      />
    </svg>
  );
}

export default SvgMailScheduled;
